export const tokenAddress = "0x89C6d98C6D336cf4F2A3CBA4E9303e48eC049027";

export const usdcAddress = "0x7bEd19B5799C09d6E39A4EB41387CFaff7Eb265F";

export const lpAddress = "0x4aded007869dcd0b4fa2d974cd0f5c4b59e28032";

export const mainNodeAddress = "0x67d956f891365d8d1157D2D4A189a84Bdb4bF0d8";

export const node1Address = "0x0b7Ad7B75e3F2837453ee6E926067266d5070c72";

export const node2Address = "0x50E790990Fc783323E4891Fa9d7eF4dA6adf2Eb5";

export const node3Address = "0x24C2C975bFA961CF0b1212668C6BC182058633b0";

export const nodePresaleAddress = "0x59CDC26A413b1cf7CD9313ad728Ad138cD700161";

export const stakingAddress = "0x24d092b86F570d74019201E5C66140e88d502294";
export const bscTokenContract = "0x28Da6d392787b258b146545507767AEEfAa592f0";
export const ethTokenContract = "0x2B3188254bA145af0ACd4F3a3f1fBAD2649fB5ff";
export const EthContract = "0xc8169C9F794bd2FBEC199c5B490E4e47D6706bbc";
export const BscContract = "0x63CEb70bC7aCDD8d27903500b74f76db2B40d931";
